
import * as THREE from "../../../libs/three.js/build/three.module.js";
import {FeatureZone} from "../../utils/FeatureZone.js";
import {TextSprite} from "../../TextSprite.js";

export class DatumAnchorPanel {

	constructor(viewer, featureZone) {
		this.viewer = viewer;
		this.featureZone = featureZone;

		if (featureZone.datumAnchor) {
			this.elContent = this._buildDisplayMode();
		} else {
			this.elContent = this._buildCreateMode();
		}
	}

	_buildCreateMode(prefill = null) {
		let anchorIconPath = Potree.resourcePath + "/icons/anchor.svg";

		let datumVal = prefill ? (prefill.datumElevation * 3.28084).toFixed(2) : '';
		let offsetVal = prefill ? (prefill.verticalOffset * 3.28084).toFixed(2) : '';
		let labelVal = prefill ? prefill.label : '';

		let el = $(`
			<div class="datum_anchor_panel" style="padding: 8px; background: rgba(0,0,0,0.2); margin-top: 4px; border-radius: 4px;">
				<div style="display: flex; align-items: center; margin-bottom: 8px;">
					<img src="${anchorIconPath}" style="width: 16px; height: 16px; margin-right: 6px; opacity: 0.7;" />
					<strong style="font-size: 12px; text-transform: uppercase; color: var(--muted-foreground, #aaa);">Datum Anchor</strong>
				</div>
				<table class="measurement_value_table" style="width: 100%;">
					<tr>
						<th style="text-align: left; padding: 2px 4px;">Datum Elevation (ft):</th>
						<td style="padding: 2px 4px;">
							<input type="number" class="datum-elev" step="0.01"
								style="width: 100%; box-sizing: border-box; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: inherit; padding: 2px 4px;"
								value="${datumVal}"
								placeholder="e.g., 30.00" />
						</td>
					</tr>
					<tr>
						<th style="text-align: left; padding: 2px 4px;">Vertical Offset (ft):</th>
						<td style="padding: 2px 4px;">
							<input type="number" class="datum-offset" step="0.01"
								style="width: 100%; box-sizing: border-box; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: inherit; padding: 2px 4px;"
								value="${offsetVal}"
								placeholder="e.g., 3.00" />
						</td>
					</tr>
					<tr>
						<th style="text-align: left; padding: 2px 4px;">Label:</th>
						<td style="padding: 2px 4px;">
							<input type="text" class="datum-label"
								style="width: 100%; box-sizing: border-box; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: inherit; padding: 2px 4px;"
								value="${labelVal}"
								placeholder="e.g., Invert" />
						</td>
					</tr>
					<tr>
						<th style="text-align: left; padding: 2px 4px;">Corrected Surface Elev:</th>
						<td style="padding: 2px 4px;" class="datum-corrected-display">--</td>
					</tr>
				</table>
				<div style="margin-top: 8px;">
					<label style="cursor: pointer; font-size: 12px;">
						<input type="checkbox" class="datum-create-visual" /> Create visual landmark
					</label>
				</div>
				<div style="display: flex; gap: 6px; margin-top: 8px;">
					<button class="datum-save-btn" style="flex: 1; padding: 4px 8px; cursor: pointer; background: var(--utility-blue, #3b82f6); color: white; border: none; border-radius: 3px;">Save</button>
					<button class="datum-cancel-btn" style="flex: 1; padding: 4px 8px; cursor: pointer; background: rgba(255,255,255,0.15); color: inherit; border: 1px solid rgba(255,255,255,0.2); border-radius: 3px;">Cancel</button>
				</div>
			</div>
		`);

		// Live corrected elevation display
		let updateCorrected = () => this._updateCorrectedDisplay(el);
		el.find(".datum-elev").on("input", updateCorrected);
		el.find(".datum-offset").on("input", updateCorrected);

		// Initial display if prefilled
		if (prefill) {
			this._updateCorrectedDisplay(el);
		}

		// Save
		el.find(".datum-save-btn").on("click", () => {
			this._onSave(el);
		});

		// Cancel
		el.find(".datum-cancel-btn").on("click", () => {
			this.elContent.remove();
			if (this.onClose) {
				this.onClose();
			}
		});

		return el;
	}

	_buildDisplayMode() {
		let datum = this.featureZone.datumAnchor;
		let anchorIconPath = Potree.resourcePath + "/icons/anchor.svg";

		let datumFt = (datum.datumElevation * 3.28084).toFixed(2);
		let offsetFt = (datum.verticalOffset * 3.28084).toFixed(2);
		let correctedFt = ((datum.datumElevation + datum.verticalOffset) * 3.28084).toFixed(2);

		let visualInfo = "";
		if (datum.derivedLandmarkId) {
			visualInfo = `
				<tr>
					<th style="text-align: left; padding: 2px 4px;">Visual:</th>
					<td style="padding: 2px 4px;">${datum.derivedLandmarkId}</td>
				</tr>
			`;
		}

		let el = $(`
			<div class="datum_anchor_panel" style="padding: 8px; background: rgba(0,0,0,0.2); margin-top: 4px; border-radius: 4px;">
				<div style="display: flex; align-items: center; margin-bottom: 8px;">
					<img src="${anchorIconPath}" style="width: 16px; height: 16px; margin-right: 6px; opacity: 0.7;" />
					<strong style="font-size: 12px; text-transform: uppercase; color: var(--muted-foreground, #aaa);">Datum Anchor</strong>
				</div>
				<table class="measurement_value_table" style="width: 100%;">
					<tr>
						<th style="text-align: left; padding: 2px 4px;">Datum Elev:</th>
						<td style="padding: 2px 4px;">${datumFt} ft</td>
					</tr>
					<tr>
						<th style="text-align: left; padding: 2px 4px;">Offset:</th>
						<td style="padding: 2px 4px;">${offsetFt} ft</td>
					</tr>
					<tr>
						<th style="text-align: left; padding: 2px 4px;">Label:</th>
						<td style="padding: 2px 4px;">${datum.label}</td>
					</tr>
					<tr>
						<th style="text-align: left; padding: 2px 4px;">Corrected Surface:</th>
						<td style="padding: 2px 4px;">${correctedFt} ft</td>
					</tr>
					${visualInfo}
				</table>
				<div style="display: flex; gap: 6px; margin-top: 8px;">
					<button class="datum-edit-btn" style="flex: 1; padding: 4px 8px; cursor: pointer; background: rgba(255,255,255,0.15); color: inherit; border: 1px solid rgba(255,255,255,0.2); border-radius: 3px;">Edit</button>
					<button class="datum-remove-btn" style="flex: 1; padding: 4px 8px; cursor: pointer; background: var(--signal-red, #ef4444); color: white; border: none; border-radius: 3px;">Remove</button>
				</div>
			</div>
		`);

		el.find(".datum-edit-btn").on("click", () => {
			this._onEdit(el);
		});

		el.find(".datum-remove-btn").on("click", () => {
			this._onRemove();
		});

		return el;
	}

	_updateCorrectedDisplay(el) {
		let datumFt = parseFloat(el.find(".datum-elev").val());
		let offsetFt = parseFloat(el.find(".datum-offset").val());
		let display = el.find(".datum-corrected-display");

		if (isNaN(datumFt) || isNaN(offsetFt)) {
			display.text("--");
			return;
		}

		let correctedFt = (datumFt + offsetFt).toFixed(2);
		display.text(`${correctedFt} ft`);
	}

	_onSave(el) {
		let datumFt = parseFloat(el.find(".datum-elev").val());
		let offsetFt = parseFloat(el.find(".datum-offset").val());
		let label = el.find(".datum-label").val().trim();

		if (isNaN(datumFt)) {
			alert("Please enter a valid datum elevation.");
			return;
		}
		if (isNaN(offsetFt)) {
			alert("Please enter a valid vertical offset.");
			return;
		}
		if (!label) {
			alert("Please enter a label.");
			return;
		}

		// Convert feet to meters for storage
		let datumElevM = datumFt / 3.28084;
		let offsetM = offsetFt / 3.28084;

		let datumAnchor = {
			datumElevation: datumElevM,
			verticalOffset: offsetM,
			label: label,
			derivedLandmarkId: null,
		};

		// Handle visual landmark creation
		let createVisual = el.find(".datum-create-visual").is(":checked");
		if (createVisual) {
			// Compute raw pointcloud surface elevation on-demand
			let result = this.featureZone.computeSurfaceElevation(this.viewer.scene.pointclouds);
			if (!result) {
				alert("No surface elevation could be computed. Ensure points are loaded for this landmark.");
				return;
			}
			let rawSurface = result.elevation;

			// Place sphere at rawSurface - verticalOffset (in raw space)
			let rawDerivedElev = rawSurface - offsetM;
			let derived = this._createDerivedLandmark(rawDerivedElev, label);
			datumAnchor.derivedLandmarkId = derived.properties.id;
		}

		// Store on the feature zone
		this.featureZone.datumAnchor = datumAnchor;

		// Add 3D anchor indicator
		this._addAnchorIndicator();

		// Fire event on the feature zone
		this.featureZone.dispatchEvent({
			type: "datum_anchor_changed",
			featureZone: this.featureZone,
			datumAnchor: datumAnchor,
		});

		// Replace panel with display mode
		let displayEl = this._buildDisplayMode();
		this.elContent.replaceWith(displayEl);
		this.elContent = displayEl;
	}

	_onEdit(el) {
		let datum = this.featureZone.datumAnchor;
		let hadDerived = !!datum.derivedLandmarkId;

		let prefill = {
			datumElevation: datum.datumElevation,
			verticalOffset: datum.verticalOffset,
			label: datum.label,
		};

		// Remove existing derived landmark before re-creating
		this._removeDerivedLandmark();

		// Remove 3D indicator
		this._removeAnchorIndicator();

		this.featureZone.datumAnchor = null;

		let createEl = this._buildCreateMode(prefill);
		this.elContent.replaceWith(createEl);
		this.elContent = createEl;

		// If there was a visual landmark, pre-check the checkbox
		if (hadDerived) {
			this.elContent.find(".datum-create-visual").prop("checked", true);
		}
	}

	_onRemove() {
		// Remove derived landmark if it exists
		this._removeDerivedLandmark();

		// Remove 3D indicator
		this._removeAnchorIndicator();

		// Clear datum
		this.featureZone.datumAnchor = null;

		// Fire event
		this.featureZone.dispatchEvent({
			type: "datum_anchor_changed",
			featureZone: this.featureZone,
			datumAnchor: null,
		});

		// Remove panel
		this.elContent.remove();
		if (this.onClose) {
			this.onClose();
		}
	}

	_createDerivedLandmark(derivedElevM, derivedLabel) {
		let parent = this.featureZone;
		let parentId = parent.properties.id || parent.name;
		let thickness = 0.1;

		let properties = {
			id: `derived_${parentId}_${Date.now()}`,
			label: derivedLabel,
			min_height: derivedElevM - thickness / 2,
			max_height: derivedElevM + thickness / 2,
			derived_from: parentId,
		};

		let zone = new FeatureZone(
			parent.polygon.slice(),
			properties.min_height,
			properties.max_height,
			properties
		);
		zone.derivedFrom = parentId;

		// Hide the polygon volume — sphere-only visual
		zone.mesh.visible = false;
		zone.frame.visible = false;

		// Add orange sphere at derived elevation (local coords relative to centroid).
		// Potree sets renderer.sortObjects = false, so draw order follows
		// scene graph traversal order. We insert the sphere BEFORE the label
		// so the label draws on top.
		let sphereGeometry = new THREE.SphereGeometry(0.3, 12, 12);
		let sphereMaterial = new THREE.MeshBasicMaterial({
			color: 0xff6600,
			depthTest: false,
			depthWrite: false,
			transparent: true,
			opacity: 0.999,
		});
		let sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
		sphere.position.set(0, 0, derivedElevM);

		// Insert sphere before the label in the zone's child list
		let labelIndex = zone.children.indexOf(zone.label);
		zone.children.splice(labelIndex, 0, sphere);
		sphere.parent = zone;

		zone.derivedSphere = sphere;

		this.viewer.scene.addFeatureZone(zone);
		return zone;
	}

	_removeDerivedLandmark() {
		let datum = this.featureZone.datumAnchor;
		if (!datum || !datum.derivedLandmarkId) {
			return;
		}

		let derived = this._findDerivedZone(datum.derivedLandmarkId);
		if (derived) {
			this.viewer.scene.removeFeatureZone(derived);
		}
	}

	_findDerivedZone(derivedId) {
		return this.viewer.scene.featureZones.find(
			z => z.properties.id === derivedId
		) || null;
	}

	// Add a small anchor indicator sprite above the landmark label in 3D
	_addAnchorIndicator() {
		this._removeAnchorIndicator();

		let indicator = new TextSprite("\u2693");
		indicator.setBorderColor({ r: 0, g: 0, b: 0, a: 0.0 });
		indicator.setBackgroundColor({ r: 0, g: 0, b: 0, a: 0.0 });
		indicator.material.depthTest = false;
		indicator.material.depthWrite = false;
		indicator.material.transparent = true;
		// Position above the label (local coords, label is at maxHeight)
		indicator.position.set(0, 0, this.featureZone.maxHeight + 1.5);
		this.featureZone.add(indicator);
		this.featureZone._datumIndicator = indicator;
	}

	_removeAnchorIndicator() {
		if (this.featureZone._datumIndicator) {
			this.featureZone.remove(this.featureZone._datumIndicator);
			this.featureZone._datumIndicator = null;
		}
	}
}
